// src/socket.js
import { io } from 'socket.io-client';

//const SOCKET_SERVER_URL = `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.hostname}:8000`;

let socket = null;

export const getSocket = () => {
  if (!socket) {
    const user_id = localStorage.getItem("user_id") || "GuestUser";
    const meeting_id = localStorage.getItem("meeting_id") || "defaultRoom";

    // socket = io(SOCKET_SERVER_URL, {
    //   transports: ["websocket"],
    //   query: { user_id, meeting_id }
    // });
    // 👇 Connect via same domain and HTTPS (let nginx proxy to 8000)
    socket = io('/', {
        path: '/socket.io', // default path
        transports: ["websocket"],
        query: { user_id, meeting_id }
      });

    socket.on('connect', () => {
      console.log('Connected with socket ID:', socket.id);
      socket.emit("userconnect", {
        displayName: user_id,
        meetingid: meeting_id
      });
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
    });
  }

  return socket;
};
